if (window && window.OrganizationalStructureControl) {
  module.exports = window.OrganizationalStructureControl;
} else {
  module.exports = {};
}
